import { defineStore } from "pinia";
import ChatApi from "@/api/chat.api.ts";

const messages = ref<any>([]);
const isMessagesLoading = ref(false);
const isMessageSending = ref(false);

const useAssessmentChatStore = defineStore('assessmentChat', () => {
    async function getMessages(planUuid: string, taskUuid: string, sessionUuid: string) {
        if(!planUuid || !taskUuid || !sessionUuid) {
            return;
        }

        isMessagesLoading.value = true;
        return await ChatApi.getMessages(planUuid, taskUuid, sessionUuid)
            .then(({data}) => {
                messages.value = data.data.reverse();
            })
            .finally(() => {
                isMessagesLoading.value = false;
            })
    }

    async function sendMessage(planUuid: string, taskUuid: string, sessionUuid: string, message: any) {
        return await ChatApi.sendMessage(
            planUuid,
            taskUuid,
            sessionUuid,
            message
        ).then((message) => {
            let existedMessage = messages.value.find(( m => m.uuid === message.uuid ));

            if(existedMessage) {
                existedMessage.value = message.value;
                existedMessage.files = message.files;
            } else {
                messages.value.push(message);
            }
            return Promise.resolve(message);
        }).finally(() => {
            isMessageSending.value = false;
        })
    }

    async function deleteMessage(messageUuid: string) {
        return await ChatApi.deleteMessage(messageUuid).then((message) => {
            if (message) {
                let indexMessage = messages.value.findIndex(((m: any) => m.uuid === message ));
                if (indexMessage !== -1) {
                    messages.value.splice(indexMessage, 1);
                }
            }
            
            return Promise.resolve(message);
        })
    }

    function clearState() {
        messages.value = [];
        isMessagesLoading.value = false;
    }

    return {
        messages,
        isMessagesLoading,
        getMessages,
        clearState,
        sendMessage,
        deleteMessage,
        isMessageSending
    }
});

export default useAssessmentChatStore;